/**
 * OpenRouter provider adapter. See groq.js for the shared adapter contract
 * and the client-side-key caveat (accepted for this dev/personal-use version).
 */

const API_URL = "https://openrouter.ai/api/v1/chat/completions";
const DEFAULT_MODEL = "openrouter/auto";

const SYSTEM_PROMPT =
  "You are the AI fallback for smartcalcAi, a calculator chat app. Answer briefly and plainly. " +
  "If the question is actually a calculation, say so and suggest the user rephrase it as a direct " +
  "calculation query (e.g. '15% of 2500', 'emi for 5 lakh at 8.5% for 5 years').";

async function ask(query) {
  const apiKey = process.env.REACT_APP_OPENROUTER_API_KEY;
  if (!apiKey || !query) return null;

  const model = process.env.REACT_APP_OPENROUTER_MODEL || DEFAULT_MODEL;

  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${apiKey}`,
      // Optional but recommended by OpenRouter for attribution; harmless if ignored.
      "HTTP-Referer": typeof window !== "undefined" ? window.location.origin : "",
      "X-Title": "smartcalcAi",
    },
    body: JSON.stringify({
      model,
      messages: [
        { role: "system", content: SYSTEM_PROMPT },
        { role: "user", content: query },
      ],
      max_tokens: 300,
      temperature: 0.4,
    }),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => null);
    console.error("OpenRouter provider error:", res.status, error);
    return null;
  }
  const data = await res.json();
  const text = data?.choices?.[0]?.message?.content?.trim();
  return text || null;
}

const openrouterProvider = { name: "openrouter", ask };
export default openrouterProvider;
